// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_home_home_module_ts":"fefbc2606a334b9c","src_app_shop_shop_module_ts":"f1a24a1ed5914ba3","src_app_elements_elements_module_ts":"badd0a52cbaf37de"}[chunkId] + ".js";
};